
import { Vue, Component } from 'vue-property-decorator';

import userx from '@/store/modules/userx';
import { Route, RawLocation } from 'vue-router';
import router from '../router';

import continueToUrl from '@/helpers/continueToUrl';

@Component
export default class Login extends Vue {
	public email = '';
	public password = '';
	public loginError = '';

	public continueUrl = '/';
	// a = (b:any) => this.$store.dispatch('a',b)
	public async login() {
		try {
			const response = await userx.signIn({email: this.email, password: this.password});
			if (response.success) {
				setTimeout(() => continueToUrl(this.continueUrl), 1000);
			} else {
				this.loginError = response.errorMessage || '';
			}
		} catch (error: any) {
			this.loginError = error.message || '';
		}
	}

	public beforeRouteEnter(
		to: Route,	from: Route,
		next: (to?: RawLocation | false | ((vm: Login) => any) | void) => void,
		): void {
		next((vm) => {
			vm.continueUrl = (to.query.continueUrl)
									? (to.query.continueUrl as string)
									: from.fullPath;
			vm.email = (to.query.email) ? (to.query.email as string) : '';
		});
	}
	public beforeRouteUpdate(
		to: Route,	from: Route,
		next: (to?: RawLocation | false | ((vm: Login) => any) | void) => void,
		): void {
		next();
		if (to.query.continueUrl) {
			this.continueUrl = to.query.continueUrl as string;
		}
	}

}
